/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Modal } from "antd";
import CostBreakdownTable from "./costBreakdownTable";

const DetailedCostBreakdown = props => {
    const [visible, setVisible] = useState(false);
    return (
        <React.Fragment>
            <h5>
                <a
                    href=""
                    onClick={e => {
                        e.preventDefault();
                        setVisible(true);
                    }}
                >{`Detailed cost breakdown`}</a>
            </h5>
            <Modal
                visible={visible}
                title={null}
                maskClosable
                footer={null}
                onCancel={() => setVisible(false)}
                bodyStyle={{
                    padding: "3rem",
                }}
            >
                <CostBreakdownTable {...props} />
            </Modal>
        </React.Fragment>
    );
};

export default DetailedCostBreakdown;
